import React, {useState, useEffect} from 'react'
import { Header } from '../components/Header';
import { Link } from 'react-router-dom';
import { Carasole } from './Carasole';
import { MobileCard } from './MobileCard';
import { 
    BASE_URL_API, 
    CDN_ELK_URL,
    IMAGE_PATH, 
    CLIENT_ID, 
    CLIENT_SECRET, 
    DATA_DECRYPTION_KEY ,
    SOP_CDN_PATH,
    USER_MANUAL_CONTRIBUTOR_CDN_PATH,
    USER_MANUAL_TASK_CREATOR_CDN_PATH,
    BASE_URL_OPENFORGE,
    IMAGE_PATH_Leader
} from '../components/Constants';
import axios from 'axios';
import crypto from 'crypto-js';
import { decryptAES } from '../components/CryptoUtils';
import { FaqSection } from '../sections/home/FaqSection';
import { LeaderBoard } from '../sections/home/LeaderBoard';
import { WorkSection } from '../sections/home/WorkSection';
import { AboutSection } from '../sections/home/AboutSection';


export const Index = () => {
    
    const [isLoading, setIsLoading] = useState(false);
    const limit = 10;
    const offset =  0;
    const [tasks, setTasks] = useState([]);
    const [contributors, setContributors] = useState([]);

    const handleImageClick = () => {
      window.open(SOP_CDN_PATH, '_blank');
    };

    const handleUserClick = () => {
      window.open(USER_MANUAL_CONTRIBUTOR_CDN_PATH, '_blank');
    };

    const handletaskClick = () => {
      window.open(USER_MANUAL_TASK_CREATOR_CDN_PATH, '_blank');
    };

    const parseSkills = (skillString) => {
    return skillString
      .match(/[^,(]+(?:\([^)]*\))?[^,]*/g)
      ?.map(item => item.trim())
      .filter(Boolean) || [];
    };

    function transformData(input) {

      const inputComplexity = {
        Medium: input.complexity_counts.Medium,
        High: input.complexity_counts.High,
        Low: input.complexity_counts.Low,
    };
  
      const fetch_records = input.data.map((record) => ({
        artifact_id: record.artifact_id,
        real_name: record.real_name,
        submitted_on:record.submitted_on,
        tracker_id: record.tracker_id,
        user_name: record.user_name, 
        assign_to: {
          label: "Others",
          value: record.assign_to
            ? record.assign_to.split(",").map((item) => item.trim())
            : [], 
        },
        category: { label: "Category", value: [record.category] },
        complexity: { label: "Complexity Level", value: [record.complexity] },
        descriptions: { label: "Descriptions", value: [record.descriptions] },
        documents: { label: "Documents", value: [record.documents] },
        expected_outcome: { label: "Expected Outcome", value: [record.expected_outcome] },
        how_to_submit: { label: "How to Submit", value: [record.how_to_submit] },
        last_submission_date_1: { label: "Last Submission Date", value: [record.last_submission_date_1] },
        mentor_s_1: { label: "Others", value: [record.mentor_s_1] },
        mode_of_the_task: { label: "Others", value: [record.mode_of_the_task] },
        mode_of_the_task_1: { label: "Others", value: [record.mode_of_the_task_1] },
        product_name_1: { label: "Product Name", value: [record.product_name_1] },
        publisher_details: { label: "Publisher Details", value: [record.publisher_details] },
        reference_url: { label: "Reference URL", value: [record.reference_url] },
        repository_url: { label: "Repository URL", value: [record.repository_url] },
        skills_and_expertise:  {
          label: "Skills and Expertise",
          value: record.skills_and_expertise
            ? parseSkills(record.skills_and_expertise)
            : [], 
        },
        submitted_real_name: { label: "Others", value: [record.submitted_real_name] },
        submitted_user_name: { label: "Others", value: [record.submitted_user_name] },
        title: { label: "Title", value: [record.title] },
        what_you_ll_do: { label: "Others", value: [record.what_you_ll_do] },
      }));
    
      return {
        fetch_records,
        total_complexity : [
          { label: "All", label_count: inputComplexity.Medium + inputComplexity.High + inputComplexity.Low },
          { label: "Low", label_count: inputComplexity.Low },
          { label: "Medium", label_count: inputComplexity.Medium },
          { label: "High", label_count: inputComplexity.High }
      ],
        total_records: input.total_hits,
      };
    }  
     
    // Trigger handleRecords when sortValue changes
    useEffect(() => {
        const handleRecords = async () => {
            try {
              
              const ts = Math.floor(Date.now() / 1000); // Get the current Unix timestamp

              const hmacStr = CLIENT_SECRET + CLIENT_ID + offset.toString() + limit.toString() + ts.toString();
              const hmacHash = crypto.SHA256(hmacStr).toString(crypto.enc.Hex);
              const advanceFilter = JSON.stringify({status : ['Active']});

              const formData = new FormData();
              formData.append('limit', limit);
              formData.append('offset', offset);
              formData.append('order_by', 'desc');
              formData.append('advance_filter', advanceFilter);
              formData.append('client_id', CLIENT_ID);
              formData.append('ts', ts);
              formData.append('hmac', hmacHash);
              
            //   const result = await axios.post(
            //     `${BASE_URL_API}task/elk_listing`,
            //     formData
            //   );

            const queryParams = {
                limit: limit,
                offset: offset,
                order_by: 'desc',
                advance_filter: advanceFilter,
                client_id: CLIENT_ID,
                ts: ts,
                hmac: hmacHash
              };
      
              const queryString = new URLSearchParams(queryParams).toString();
      
              const result = await axios.get(`${CDN_ELK_URL}/task/elk_caching?${queryString}`);
              
              if (result.data.code === 200) {
                   
                if(result.data.secure) {
                    const encryptedData = await result.data.data;
                    const decryptedText = await decryptAES(encryptedData, DATA_DECRYPTION_KEY);
                    const flattenData = JSON.parse(decryptedText); // Assuming decrypted data is JSON
                    const output = transformData(flattenData)  
                    setTasks(output.fetch_records);
                } else {
                    
                    setTasks(result.data.data.fetch_records);
                }

              } else {
                setTasks([]);
                
              }
            } catch (error) {
                setTasks([]);
              console.error("There was a problem fetching the tasks:", error);
            }
          };
          handleRecords();
          
    }, [offset, limit]);

    // Trigger handleRecords when sortValue changes
    useEffect(() => {
      const handleContributors = async () => {
          try {
              setIsLoading(true);
            
            const ts = Math.floor(Date.now() / 1000); // Get the current Unix timestamp

            const hmacStr = CLIENT_SECRET + CLIENT_ID + ts.toString();
            const hmacHash = crypto.SHA256(hmacStr).toString(crypto.enc.Hex);

            const formData = new FormData();
            formData.append('client_id', CLIENT_ID);
            formData.append('ts', ts);
            formData.append('hmac', hmacHash);
            
            // const result = await axios.post(`${BASE_URL_API}get_collab_leader_board_list`, formData);
            const result = await axios.get(`https://cdn-opfg.dl6.in/openforge_dashboard/openforge_dashboard.json`);
            // const result = await axios.get(`https://dev-crt-opfg.dl6.in/openforge_dashboard/openforge_dashboard.json`);
            // console.log('result 109', result.data.leader_board_data_qry_data.length);
            //const result = await response.json();
            if (result.data.leader_board_data_qry_data.length > 0) {
                 
              // if(result.data.secure) {
              //     const encryptedData = await result.data.data;
              //     const decryptedText = await decryptAES(encryptedData, DATA_DECRYPTION_KEY);
              //     const output = JSON.parse(decryptedText); // Assuming decrypted data is JSON
              //     console.log("output contributors", output);
              //     setIsLoading(false);
              //     setContributors(output);
              // } else {
                  
                  setIsLoading(false);
                  setContributors(result.data.leader_board_data_qry_data);
              // }

            } else {
              setIsLoading(false);
              setContributors([]);
              
            }
          } catch (error) {
              setIsLoading(false);
              setContributors([]);
            console.error("There was a problem fetching the tasks: 135", error);
          }
        };
        handleContributors();
        // console.log("contributors ini", contributors);
  }, []);


  return (
        <>
            <Header/>
             <div style={{marginTop: '54px'}}>
                <section className="header-section">
                <div className="container">
                    <div className="row">
                        <div className="col-sm-7">
                            <h1>Collaborate with Government: Empower India's Digital Future</h1>
                            <p className="lead">Join the movement to revolutionize e-governance. Contribute your skills to real government projects, earn recognition, and become a Digital Champion of India.</p>
                            <div className="cta-buttons">
                                <Link to="/collabwithgov/contributionaltasklist" className="btn btn-light btn-lg" style={{color: '#202020 !important'}}>Explore Challenges</Link>
                            </div>
                        </div>
                    </div>
                </div>
                </section>
                
                <section className="explor-section" id="explore_1" style={{backgroundImage: `url(${IMAGE_PATH}/explore_frame.svg)`,backgroundRepeat: 'no-repeat'}}   aria-labelledby="explore-heading">
                <div className="container text-left  pt-4 pb-6 pl-0 pr-0">
                    <div className="row mx-auto my-auto justify-content-center">
                        <div className="col-sm-12 mt-4">
                            <div className="d-flex justify-content-between align-items-center mb-2" id="view_all">
                            <div>
                                <h1  id="explore-heading">Explore <span style={{color:'#00675B'}}>Challenges</span></h1>
                                <h2 id="work1">Solve real-world problems and contribute skills that makes a difference</h2>
                            </div>
                            <Link to="/collabwithgov/contributionaltasklist"><button className="btn btn-outline-dark view-all-btn">View All</button></Link>
                            </div>
                        </div>
                    </div>
                    {
                    (tasks.length > 0) ?
                        <Carasole 
                        tasks={tasks}
                        IMAGE_PATH={IMAGE_PATH}
                        />
                    : 
                        ''
                    }
                </div>
                </section>
                <section className="explor-section" id="explore_2"   aria-labelledby="explore-heading-2">
                <div className="container text-left  pt-4">
                    <div className="row mx-auto my-auto justify-content-center">
                        <div className="col-sm-12 mt-4 mb-2">
                        <div className="d-flex justify-content-between align-items-center mb-2" id="view_all">
                            <div>
                                <h1  id="explore-heading-2">Explore <span style={{color:"#00675B"}}>Challenges</span></h1>
                                <h2 id="work1">Solve real-world problems and contribute skills that makes a difference</h2>
                            </div>
                        </div>
                        </div>
                    </div>
                    <div id="carouselExampleControls" className="react-multi-carousel-list">
                        {
                            (tasks.length > 0) ? (tasks.slice(0, 4).map((task, index) => (
                                <MobileCard 
                                key={index} 
                                task={task} 
                                IMAGE_PATH={IMAGE_PATH}/>
                            ))): ''    
                        } 
                    </div>
                        <div className="align-items-center mb-4 mt-1" id="view_all_1a">
                            <Link to="/collabwithgov/contributionaltasklist"><button className="btn btn-outline-dark view-all-btn">View All Challenges</button></Link>
                        </div>
                </div>
            </section>
                
              <WorkSection/>
              <AboutSection 
              IMAGE_PATH={IMAGE_PATH}
              onImageClick={handleImageClick} 
              onUserClick={handleUserClick} 
              onTaskClick={handletaskClick}
              />
              {
                (contributors.length > 0) 
                ?
                <LeaderBoard
                IMAGE_PATH={IMAGE_PATH}
                IMAGE_PATH_Leader={IMAGE_PATH_Leader}
                contributors={contributors}
                BASE_URL_OPENFORGE={BASE_URL_OPENFORGE}/>
                :
                ''
              }
              <FaqSection/>
            </div>
        </>
  )
};